export enum FileTypes {
  PDF = "application/pdf",
  IMAGES = "image/",
  DOC = "application/msword",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  XLS = "application/vnd.ms-excel",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  CSV = "text/csv",
  PNG = "image/png",
  JPEG = "image/jpeg",
  JPG = "image/jpg",
}
